import { useCart } from "./cart.context";
import { useOpenCartFromNavigation } from "./use-open-cart-from-navigation.hook";

export function OpenCartFromNavigation() {
	const { cartDisclosure, pharmacyItems } = useCart();
	useOpenCartFromNavigation(
		cartDisclosure.open,
		pharmacyItems.length > 0,
		cartDisclosure.isOpen,
	);
	return null;
}
